// ============================================================================
// FRENCH TRANSLATIONS - JÉSUS N'EST PAS...
// ============================================================================
// Clarifications importantes sur qui est vraiment Jésus

export const jesusIsNot = [
  {
    category: "amour",
    text: "Jésus n'est pas homophobe - Son amour infini inclut chacun comme il est",
    reference: "1 Jean 4:8 - Dieu est amour",
    context: "L'amour de Dieu est inclusif et accepte chaque personne dans sa diversité"
  },
  {
    category: "égalité",
    text: "Jésus n'est pas misogyne - Son amour infini valorise chaque femme",
    reference: "Luc 8:1-3 - Les femmes qui suivaient Jésus",
    context: "Jésus révolutionne son époque en incluant et honorant les femmes"
  },
  {
    category: "paix",
    text: "Jésus n'est pas meurtrier - Son amour infini donne la vie à tous",
    reference: "Jean 10:10 - Je suis venu pour qu'ils aient la vie",
    context: "Jésus apporte la vie, la guérison et la restauration à chacun"
  },
  {
    category: "unité",
    text: "Jésus n'est pas diviseur - Son amour infini unit toute l'humanité",
    reference: "Galates 3:28 - Il n'y a plus ni Juif ni Grec",
    context: "L'amour de Jésus transcende toutes les barrières humaines"
  },
  {
    category: "amour",
    text: "Jésus n'est pas raciste - Son amour infini embrasse toutes les cultures",
    reference: "Matthieu 28:19 - Faites de toutes les nations des disciples",
    context: "L'amour de Jésus célèbre la diversité de toute l'humanité"
  },
  {
    category: "justice",
    text: "Jésus n'est pas oppresseur - Son amour infini libère et guérit chacun",
    reference: "Luc 4:18 - Il m'a envoyé pour proclamer aux captifs la délivrance",
    context: "L'amour de Jésus apporte liberté et guérison à tous"
  },
  {
    category: "humilité",
    text: "Jésus n'est pas orgueilleux - Son amour infini se met au service de tous",
    reference: "Philippiens 2:7 - Il s'est dépouillé lui-même",
    context: "L'amour de Jésus s'exprime par l'humilité et le service"
  },
  {
    category: "pardon",
    text: "Jésus n'est pas vengeur - Son amour infini pardonne toujours",
    reference: "Luc 23:34 - Père, pardonne-leur car ils ne savent ce qu'ils font",
    context: "L'amour de Jésus offre le pardon même dans la souffrance"
  },
  {
    category: "compassion",
    text: "Jésus n'est pas insensible - Son amour infini ressent chaque douleur",
    reference: "Jean 11:35 - Jésus pleura",
    context: "L'amour de Jésus partage profondément nos joies et nos peines"
  },
  {
    category: "vérité",
    text: "Jésus n'est pas menteur - Son amour infini est pure vérité",
    reference: "Jean 14:6 - Je suis le chemin, la vérité et la vie",
    context: "L'amour de Jésus est la vérité la plus authentique qui existe"
  },
  {
    category: "paix",
    text: "Jésus n'est pas violent - Son amour infini apporte la paix véritable",
    reference: "Matthieu 5:9 - Heureux ceux qui procurent la paix",
    context: "L'amour de Jésus transforme les conflits en réconciliation"
  },
  {
    category: "générosité",
    text: "Jésus n'est pas avare - Son amour infini donne sans compter",
    reference: "2 Corinthiens 8:9 - Pour vous il s'est fait pauvre",
    context: "L'amour de Jésus est généreux au point de tout donner"
  },
  {
    category: "amour",
    text: "Jésus n'est pas partial - Son amour infini accueille chaque être unique",
    reference: "Actes 10:34 - Dieu ne fait point acception de personnes",
    context: "L'amour de Jésus célèbre l'unicité de chaque personne, handicap inclus"
  },
  {
    category: "universalité",
    text: "Jésus n'a point de frontières - Son amour infini dépasse toutes les limites",
    reference: "Romains 10:12 - Il n'y a aucune différence entre le Juif et le Grec",
    context: "Il n'y a point de frontière pour Jésus : ni géographique, ni culturelle, ni sociale"
  },
  {
    category: "respect",
    text: "Jésus n'est pas irrespectueux - Il enseigne le respect de soi, des femmes, des autres",
    reference: "Matthieu 22:39 - Tu aimeras ton prochain comme toi-même",
    context: "Le respect est une sagesse certaine : respecte ta vie, ton corps, la femme comme toi-même, les autres"
  },
  {
    category: "paix",
    text: "Jésus n'est pas diviseur - Il unit juifs, arabes et toutes dénominations dans la paix",
    reference: "Éphésiens 2:14 - Il est notre paix, lui qui des deux n'en a fait qu'un",
    context: "Célébrons nos diversités plutôt que d'en faire des querelles de mots et des guerres"
  },
  {
    category: "vérité",
    text: "Jésus n'est pas menteur - Il dénonce le mensonge et la manipulation",
    reference: "Jean 8:44 - Le diable est le père du mensonge",
    context: "Jésus expose les mensonges et manipulations qui blessent les âmes"
  },
  {
    category: "générosité",
    text: "Jésus n'est pas cupide - Sa générosité dépasse largement la dîme",
    reference: "Luc 21:3 - Cette pauvre veuve a mis plus que tous les autres",
    context: "La générosité de Jésus est plus forte que l'obligation de la dîme"
  },
  {
    category: "justice",
    text: "Jésus n'est pas complice du silence - Il protège par une saine justice",
    reference: "Matthieu 18:6 - Celui qui scandalisera un de ces petits",
    context: "Le silence qui couvre les fautes sans protéger les autres n'est pas la sagesse de Jésus"
  }
];

export default jesusIsNot;
